"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPipetteFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.pipette_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "pipette_filled_svg__transparent_box" },
            React.createElement("path", { className: "pipette_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "pipette_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "pipette_filled_svg__FILLED" },
            React.createElement("path", { d: "M9.17 22.28l-.71-.69-.7.71C7.47 22.59 5 25.21 5 27.58a3.5 3.5 0 007 0c0-2.51-2.54-5.02-2.83-5.3zM8.66 18.1l2.21 2.21 9.37-6.81-4.76-4.77-6.82 9.37zM25.74 3.25A4.45 4.45 0 0022 1.65a4.2 4.2 0 00-2.51 1.45l-2 2-.79-.8-1.41 1.41 8 8 1.42-1.42-.78-.78 2-2A4.19 4.19 0 0027.33 7a4.45 4.45 0 00-1.59-3.75z" }))));
}
exports.default = SvgPipetteFilled;
//# sourceMappingURL=PipetteFilled.js.map